const debug = require('debug')('CombatController');

class CombatController {
  constructor(enemies, party, onUpdate) {
    this.enemies = enemies;
    this.party = party;
    this.currentEnemyIndex = 0;
    this.isPlayerTurn = true;
    this.onUpdate = onUpdate; // Callback to update UI
  }

  calculateDamage(attacker, defender) {
    const attack = attacker.attackPower;
    const defense = defender.defense;
    const agility = defender.agility;
    const hitRoll = Math.random();
    let damage = Math.max(attack - defense, 0);
    if (hitRoll > 1 - agility / 100) {
      damage = 0; // Missed attack due to agility
    }
    return damage;
  }

  handlePlayerAttack(enemyIndex) {
    const enemy = this.enemies[enemyIndex];
    if (!enemy || enemy.health <= 0) return; // Enemy already defeated or index out of range

    const damage = this.calculateDamage(this.party.getAttacker(), enemy);
    enemy.receiveDamage(damage);

    if (enemy.health <= 0) {
      enemy.health = 0;
      debug(`${enemy.name} defeated.`);
      // Check if all enemies are defeated
      if (this.enemies.every(enemy => enemy.health <= 0)) {
        this.handleCombatEnd(true);
      }
    }

    this.isPlayerTurn = false;
    const isCombatOver = this.enemies.every(enemy => enemy.health <= 0);
    this.onUpdate({
      enemy,
      enemyIndex,
      damage,
      victory: isCombatOver ? true : undefined
    }); // Notify component to update UI
  }

  handleEnemyTurn(enemy, context) {
    let damage = 0;
    if (enemy.health > 0) {
      damage = this.calculateDamage(enemy, this.party.getDefender());
      debug(`Enemy ${enemy.name} attacks party for ${damage} damage.`);

      this.party.resources.delta({ health: -damage }, context); // Notify component to update UI
      if (this.party.resources.attribs.health.value <= 0) {
        this.handleCombatEnd(false);
      }
    }
    this.isPlayerTurn = true;
    return damage;
  }

  handleCombatEnd(partyWon) {
    // Implement any end-of-combat logic here, such as rewards for victory or game over handling
    this.onUpdate({ victory: partyWon }); // Optionally pass whether the party won or not
  }
}

export default CombatController;
